<template>
    <div class="pro_container">
        <!-- 头部 -->
        <v-header2></v-header2>
        <!-- 产品标题 -->
        <product-tool title="A1" color="#ffffff"></product-tool>
        <!-- 产品图片 -->
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1g9kqb69iqtj31hc0u0gt2.jpg"/>
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1g9kqb9j8guj31hc0u0wgi.jpg"/>
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1g9kqbbwp9bj31hc0u0tek.jpg"/>
        <img class="pro_img" src="https://wx2.sinaimg.cn/large/0067mezugy1g9kqbeqotbj31hc0u041n.jpg"/>
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1g9kqbh1l4rj31hc0u0tar.jpg"/>
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1g9kqc606j1j31hc0u0q6w.jpg"/>
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1g9kqc8vcgdj31hc0u077z.jpg"/>
        <img class="pro_img" src="https://wx1.sinaimg.cn/large/0067mezugy1g9kqcbkct7j31hc0u0tbn.jpg"/>
        <img class="pro_img" src="https://wx3.sinaimg.cn/large/0067mezugy1g9kqcei1fij31hc0u077a.jpg"/>
        <img class="pro_img" src="https://wx2.sinaimg.cn/large/0067mezugy1g9kqch0bbmj31hc0u0771.jpg"/>
        <img class="pro_img_mb" src="https://wx2.sinaimg.cn/large/0067mezugy1ggu88jqn5wj30u01hd169.jpg"/>
        <img class="pro_img_mb" src="https://wx4.sinaimg.cn/large/0067mezugy1ggu88qmos7j30u01hdafs.jpg"/>
        <img class="pro_img_mb" src="https://wx4.sinaimg.cn/large/0067mezugy1ggu88wlrpuj30u01hddzx.jpg"/>
        <img class="pro_img_mb" src="https://wx2.sinaimg.cn/large/0067mezugy1ggu88z00nxj30u01hd139.jpg"/>
        <img class="pro_img_mb" src="https://wx4.sinaimg.cn/large/0067mezugy1ggu891jponj30u01hdafw.jpg"/>
        <img class="pro_img_mb" src="https://wx1.sinaimg.cn/large/0067mezugy1ggu89bba37j30u01hde0j.jpg"/>
        <img class="pro_img_mb" src="https://wx3.sinaimg.cn/large/0067mezugy1ggu89egcdqj30u01hddxr.jpg"/>
        <img class="pro_img_mb" src="https://wx2.sinaimg.cn/large/0067mezugy1ggu89h49ysj30u01hd134.jpg"/>
        <img class="pro_img_mb" src="https://wx1.sinaimg.cn/large/0067mezugy1ggu89ja1fqj30u01hd46s.jpg"/>
        <img class="pro_img_mb" src="https://wx1.sinaimg.cn/large/0067mezugy1ggu89ltcynj30u01hdn61.jpg"/>
        <v-footer2></v-footer2>
    </div>
</template>

<script>
import {
        swiper,
        swiperSlide
    } from 'vue-awesome-swiper'
export default {
    components: {
        swiper,
        swiperSlide
    },
    data(){
        return {
           
        }
    },
    methods:{
        switchColor(type){
            this.seletedColor = type;
        }
    }
}
</script>
<style scoped>

.pro_animation .pro_colors i:nth-child(1){
	background-image: url(../../../assets/img/n/pa_1.png);
}

.pro_animation .pro_colors i:nth-child(2){
	background-image: url(../../../assets/img/n/pa_2.png);
	margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/products/A/a1.vue